import { Component, forwardRef, Host, Input, OnInit, Optional, SkipSelf } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Log } from 'src/app/core/console.log';
import { DropdownModel } from 'src/app/models/master/dropdown-model';
import { MasterService } from 'src/app/services/master.service';
import { DropdownFormControl } from 'src/app/shared/inputs/dropdown-form-control';
import { inputMgsErrs } from 'src/app/validators/message-validation';

@Component({
  selector: 'app-input-dp-title-name',
  templateUrl: './input-dp-title-name.component.html',
  styleUrls: ['./input-dp-title-name.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputDpTitleNameComponent),
      multi: true
    }
  ]
})
export class InputDpTitleNameComponent extends DropdownFormControl implements OnInit {
  @Input() label: any;
  errors = inputMgsErrs.titleName;

  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer,
    private translate: TranslateService,
    private masterService: MasterService
  ) {
    super(cc);
  }

  ngOnInit() {
    this.checkInitialControl();
    this.initDropdownList();
  }

  initDropdownList() {
    this.resetDropdownList();
    this.masterService.getTitleNames().subscribe(result => {
      this.items.push(...result);
      this.findValueFromList(this.value);
      this.setAfterLoadItemDropdown();
    }, error => {
      Log.error(error);
    });
  }

  resetDropdownList() {
    this.items = new Array<DropdownModel>();
    // this.translate.get('input.dropdown.select.province').subscribe(label => {
    //   this.items.push({ value: null, label: label, data: null });
    // });
  }

}
